export default {
  region: "ap-southeast-2",
  IdentityPoolId: "ap-southeast-2_MiO9pePil",
  UserPoolId: "ap-southeast-2:693181236168",
  ClientId: "734h7r4aqruke0bimjudq822lv",
};
